import type { M365ApprovalStatus, UISettings } from "@/types/user-settings"

// 1.1: consent scope extended to admin-enabled shared mailboxes the user already
// has access to (re-prompts everyone; keep in sync with routes/home_context.py).
export const CURRENT_M365_APPROVAL_VERSION = "1.1"

/**
 * The user's Microsoft 365 consent decision at the current consent version, or
 * undefined when they have not decided yet (or decided against an older
 * version, which re-prompts).
 *
 * Legacy back-compat: pre-status approvals (version + timestamp but no status
 * field) count as "approved" so existing users do not lose access.
 */
export function resolveM365ApprovalStatus(
  ui:
    | Pick<UISettings, "m365_approval_version" | "m365_approval_timestamp" | "m365_approval_status">
    | undefined
): M365ApprovalStatus | undefined {
  if (!ui) return undefined
  const isCurrentVersion =
    ui.m365_approval_version === CURRENT_M365_APPROVAL_VERSION &&
    Boolean(ui.m365_approval_timestamp)
  if (!isCurrentVersion) return undefined
  return ui.m365_approval_status ?? "approved"
}

/** True once the user has approved or declined at the current consent version. */
export function hasCurrentM365Decision(
  ui: Parameters<typeof resolveM365ApprovalStatus>[0]
): boolean {
  return resolveM365ApprovalStatus(ui) !== undefined
}
